<li [ngClass]="{'bg-even' : (i%2 === 0)}" 
    class="list_item" 
    *ngFor="let result of searchResults.items; index as i;">
    <a [href]="result.html_url">
        <img class="avatar" [src]="result.owner.avatar_url" /> 
        <h4 class="title">{{result.name}} 
            <small> by {{result.owner.login | uppercase}}</small> 
        </h4>
    </a>
    <span class='favorite_icon' 
        *ngIf="!checkFavorite(result)" 
        (click)="addFavorite(result)">&#9734;
    </span>
    <span class='favorite_icon favorited' 
        *ngIf="checkFavorite(result)"
        (click)="deFavorite(result)">&#9733;
    </span>
    <p class="description"> {{result.description}} </p> 
    <p> Created On: {{result.created_at | date:'fullDate'}} </p>
</li>
